<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="add()"
                >
                    <mat-icon>add</mat-icon>
                    Neue Produktdaten
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>

            <div class="main-toolbar-filter-container">
                <div class="filter-item">
                    <pixl-free-filter-input
                        [label]="'ISBN'"
                        [matIcon]="'search'"
                        [hint]="getSearchFilterHint()"
                        [minLength]="freeFilterLen"
                        (onKeyUpChange)="setIsbnFilter($event)"
                    />
                </div>
                <div class="filter-item">
                    <pixl-free-filter-input
                        [label]="'Name'"
                        [matIcon]="'search'"
                        [hint]="getSearchFilterHint()"
                        [minLength]="freeFilterLen"
                        (onKeyUpChange)="setFreeFilter($event)"
                    />
                </div>
            </div>

        </div>
        <div class="table-header-overlay"></div>
    </div>


    <div class="table-container mat-elevation-z4">
        <table
            mat-table
            [dataSource]="(products$ | async) || []"
            [trackBy]="trackById"
        >

            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >Aktionen</th>

                <td
                    mat-cell
                    *matCellDef="let product"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="edit(product)"
                        matTooltip="Datensatz editieren"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="copy(product)"
                        matTooltip="Datensatz duplizieren"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>

                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        (click)="delete(product)"
                        matTooltip="Datensatz löschen"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="isbn">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                > ISBN </th>
                <td
                    mat-cell
                    *matCellDef="let product"
                > {{ product.isbn }} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                > Name </th>
                <td
                    mat-cell
                    *matCellDef="let product"
                > {{ product.name }} </td>
            </ng-container>

            <ng-container matColumnDef="updatedAt">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                > Letzte Änderung </th>
                <td
                    mat-cell
                    *matCellDef="let product"
                > {{ product.updatedAt | date: 'dd.MM.yyyy HH:mm' }} Uhr</td>
            </ng-container>

            <ng-container matColumnDef="changedBy">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                > Geändert von </th>
                <td
                    mat-cell
                    *matCellDef="let product"
                > {{ product.changedBy }} </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
            ></tr>

        </table>

        <mat-paginator
            [length]="totalItems || 0"
            [pageSize]="pageSize"
            [pageSizeOptions]="[25, 50, 100]"
        ></mat-paginator>
    </div>
</div>